import { css, SerializedStyles } from '@emotion/react';

import { palette } from '@lib/styles/palette';

export const emphasizeText = (isDanger: boolean): SerializedStyles => css`
  color: ${isDanger ? '#da1e28' : '#24a148'};
`;

export const underLineText = <K extends keyof typeof palette>(
  color: typeof palette[K] | null,
) => css`
  color: ${color || palette.black10};
  text-decoration: underline;
`;

export const gridItem = css`
  border: 1px solid #e0e0e0;
  width: 100%;
  position: relative;
  p {
    text-align: center;
  }
  .title {
    padding: 10px 0 8px 0;
    font-size: 14px;
  }
  .content {
    font-size: 20px;
    font-weight: 500;
    padding-bottom: 8px;
  }
`;

export const infoButton = css`
  width: 23px;
  position: absolute;
  border: 0px;
  right: 0px;
  margin: 5px 5px 0 0;
`;

export const ddCommon = css`
  display: flex;
  flex-wrap: wrap;
  flex: 1 0 74%;
  align-items: center;
  justify-content: space-between;
  padding: 28px 12px 28px 4px;
  border-bottom: 1px solid #e0e0e0;
  .result-text {
    font-size: 14px;
  }
  .no-result-guide {
    flex-basis: 100%;
    margin-top: 8px;
    font-size: 13px;
  }
`;
